// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, createSubscriber } from '@atlassian/react-sweet-state';
import { actions, type Actions } from './actions.tsx';
import { getUsedLanguages, getUnusedLanguages, getActiveLanguages } from './selectors.tsx';
import { LANGUAGE_OPERATIONS, type State, type Language } from './types.tsx';

const initialState: State = {
	loading: false,
	currentOperation: {
		type: LANGUAGE_OPERATIONS.NO_OP,
		updatedLanguages: [],
		addedLanguages: [],
		languageLabel: '',
		analytics: undefined,
	},
	error: undefined,
	data: {
		languages: [],
		projectDefaultLanguage: { key: '', label: '' },
		shouldAskUserToConfirmLanguages: false,
	},
};

const Store = createStore({ initialState, actions, name: 'Languages' });

export const EnabledLanguagesSubscriber = createSubscriber<
	State,
	Actions,
	Language[],
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
>(Store, {
	selector: getUsedLanguages,
});

export const useLanguages = createHook(Store);

export const useEnabledLanguages = createHook(Store, {
	selector: getUsedLanguages,
});

export const useDisabledLanguages = createHook(Store, {
	selector: getUnusedLanguages,
});

export const useActiveLanguages = createHook(Store, {
	selector: getActiveLanguages,
});
